import { UNSTYLED } from 'ricos-content';
import { Node_Type } from 'ricos-schema';
import type { TiptapEditorPlugin } from 'ricos-types';
import { createShortcut } from 'ricos-types';

import { paragraph } from './extension';

export const pluginParagraph: TiptapEditorPlugin = {
  type: Node_Type.PARAGRAPH,
  shortcuts: [
    createShortcut({
      name: Node_Type.PARAGRAPH,
      description: 'ShortcutsSheet_Formatting_ParagraphFormat',
      keys: { macOs: 'Meta+Alt+0', windows: 'Ctrl+Alt+0' },
      command({ editorCommands }) {
        editorCommands.setBlockType(UNSTYLED);
      },
      group: 'ShortcutsSheet_Section_Formatting',
      enabled: true,
    }),
  ],
  config: {},
  tiptapExtensions: [paragraph],
};
